import { render, staticRenderFns } from "./sidebarRightSide.vue?vue&type=template&id=859e6670&scoped=true"
import script from "./sidebarRightSide.vue?vue&type=script&lang=js"
export * from "./sidebarRightSide.vue?vue&type=script&lang=js"
import style0 from "./sidebarRightSide.vue?vue&type=style&index=0&id=859e6670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859e6670",
  null
  
)

export default component.exports